import React from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultHeader } from '../../components/DefaultHeader';
import { LoadingContainer } from '../../components/LoadingContainer';
import { getAppLang } from '../../components/TranslatorComponent';
import { SITE_LINKS } from '../../constants';
import { useGetUnits } from '../../hooks/use-get-units';
import { getLessonCardProps } from '../../models/UnitPageLesson';
import {
  getCurrentLessonPosition,
  getUnitDescription,
  UnitDescriptions,
} from '../../models/UnitPageUnit';
import { Background } from '../../stories/Background';
import { LessonCarousel } from '../../stories/LessonCarousel';
import { Link } from '../../stories/Link';
import { Tag } from '../../stories/Tag';

export const UnitPage = () => {
  const __ = useTranslation().t;
  const path = window.location.pathname.split('/');
  let levelPosition = 0;
  let unitPosition = 0;
  const levelIndex = path.indexOf('level');
  const unitIndex = path.indexOf('unit');
  if (levelIndex !== -1 && unitIndex !== -1) {
    levelPosition = +path[levelIndex + 1];
    unitPosition = +path[unitIndex + 1];
  }

  const { units, isFetching, isError } = useGetUnits(levelPosition, unitPosition);

  const descriptions: UnitDescriptions = {
    en: units?.description || '',
    pt: units?.['description_pt-BR'] || '',
    es: units?.description_es || '',
  };

  const unitDescription = getUnitDescription(descriptions, getAppLang());
  const lessons = units?.lessons.map((lesson) =>
    getLessonCardProps({
      ...lesson,
      levelName: `${__('level')} ${lesson?.levelPosition || 0}`,
      buttonText: __('start'),
      levelPosition: lesson?.levelPosition || 0,
      unitPosition: units?.position || 0,
    }),
  );

  if (isError) {
    window.location.href = SITE_LINKS.HomePage;
    return null;
  }

  return (
    <>
      <DefaultHeader activeItem={__('course')} />
      <Background type="partial" className="oejr-bg-partial-pl">
        {isFetching ? (
          <LoadingContainer />
        ) : (
          <div className="oejr-page-lesson">
            <Link
              href={SITE_LINKS.LevelDetailsPage(units?.levelPosition || 0)}
              icon="arrow-left"
              variant="black-main"
              italic={false}
            >
              {__('seeAllUnits')}
            </Link>
            <div className="oejr-lesson-header">
              <Tag children={units?.name} shape="horizontal-flag" />
              <div className="oejr-lesson-header-text-wrapper">
                <h2 className="d-block d-xl-none">{unitDescription || units?.description}</h2>
                <h4 className="d-none d-xl-block">{units?.description}</h4>
                <p>{unitDescription}</p>
              </div>
            </div>
            <div className="oejr-lesson-carousel-wrapper">
              {units && (
                <LessonCarousel
                  currentLessonIndex={getCurrentLessonPosition(units.lessons)}
                  lessons={lessons}
                />
              )}
            </div>
          </div>
        )}
      </Background>
    </>
  );
};
